import blocksGrid, { randomBlocksGenerator } from '../blocks-grid'
import createWall from './wall'
import textureUrls from '../textures/urls'

// Local offset to account for world position
const colOffset = -15
const rowOffset = 6

class Pos {
  col: number
  height: number
  row: number
  width: number

  constructor(cell: string, col: number, row: number) {
    const result = cell.split('').map((n) => parseInt(n)) // Convert string to array of numbers
    //console.log('result', result)
    this.col = col + colOffset
    this.height = result[1]
    this.row = row + rowOffset
    this.width = 1
  }
}

/**
 * Example:
 * 
 * 
  `
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00 00
  00 00 00 00 00 00 00 16 16 16 16 00 00 00 00 00 00 00
  `
 */
export default function blocksGenerator({ pos, quat }) {
  //const _pos = blocksGrid
  const _pos = randomBlocksGenerator()
  let row = 0

  const cellRows = _pos.split('\n').reverse()
  const cellRowsLength = cellRows.filter((r) => r.trim().length != 0).length

  cellRows.forEach((cellRow: string, i: number) => {
    if (cellRow.trim().length != 0) {
      let col = 0
      const cellCols = cellRow.split(' ')

      cellCols.forEach((cell: string, cellI: string) => {
        if (cell.trim().length != 0) {
          const p = new Pos(cell, col, row)

          createWall({
            height: p.height,
            pos,
            quat,
            textureUrl: textureUrls.stone,
            width: p.width,
            x: p.col,
            xo: row != 0 ? 0.5 : 0,
            z: p.row,
            zo: col,
          })

          col++
        }
      })
    }

    row++
  })
  //console.log('cellRows', cellRows)
}
